var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNecklace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2C2.75 1.58579 2.41421 1.25 2 1.25C1.58579 1.25 1.25 1.58579 1.25 2C1.25 7.93706 6.06294 12.75 12 12.75C17.9371 12.75 22.75 7.93706 22.75 2C22.75 1.58579 22.4142 1.25 22 1.25C21.5858 1.25 21.25 1.58579 21.25 2C21.25 7.10863 17.1086 11.25 12 11.25C6.89137 11.25 2.75 7.10863 2.75 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.4568C8 18.9071 9.60777 20.4409 10.7847 21.3695C11.3175 21.7898 11.5839 22 12 22C12.4161 22 12.6825 21.7898 13.2153 21.3695C14.3922 20.441 16 18.9071 16 17.4568C16 15.034 13.7999 14.1295 12 16.001C10.2001 14.1295 8 15.034 8 17.4568Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecklace);
export default __webpack_public_path__ + "static/media/necklace.38c865a4e5f83f7afe776848ff3a78c0.svg";
export { ForwardRef as ReactComponent };